<template>
  <v-card :loading="loading" v-bind="$attrs" v-on="$listeners">
    <v-card-title>
      <v-row>
        <v-col>
          <span class="headline">My Dealer Incentives</span>
        </v-col>
        <v-col class="text-right">
          <v-btn small color="primary" :to="{ name: 'dealersIncentives' }">View All</v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <span v-if="selectedFiscalYear && selectedFiscalYear.fiscalYearStart && selectedFiscalYear.fiscalYearEnd">
        <b>
          ({{ selectedFiscalYear.fiscalYearStart | formatDateClient("MM/DD/YYYY", selectedClient) }} -
          {{ selectedFiscalYear.fiscalYearEnd | formatDateClient("MM/DD/YYYY", selectedClient) }})
        </b>
        <br />
      </span>
      Summary of dealers reporting to you.
      <br />
      Currently displaying only dealers with payouts.
    </v-card-subtitle>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        dense
        :options.sync="options"
        :server-items-length="total"
        hide-default-footer
      >
        <template v-slot:item.name="{ item }">
          <a @click.prevent="viewDealerDetails(item.organizationId)" href="#">
            {{ item.name }}
          </a>
        </template>
        <template v-slot:item.earningAmount="{ item }">
          {{ item.earningAmount || 0 | toCurrency }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DealerIncentivesWidget",

  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      options: {
        itemsPerPage: 10,
        page: 1,
        sortDesc: [true]
      },
      headers: [
        { text: "Dealer Number", value: "organizationKey" },
        { text: "Dealer Name", value: "name" },
        { text: "Earned", value: "earningAmount" }
      ]
    };
  },
  computed: {
    ...mapGetters(["selectedParticipant", "selectedProgram", "selectedClient", "selectedFiscalYear"])
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true
    },
    selectedFiscalYear() {
      this.fetchData();
    },
    selectedParticipant() {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      const organizationId = this.selectedParticipant?.organization?.id;
      const fiscalYear = this.selectedFiscalYear;

      if (!organizationId) {
        this.items = [];
        this.total = 0;
        this.loading = false;
        return;
      }

      this.loading = true;

      let filters = {
        parentOrganization: { id: organizationId }
      };

      if (fiscalYear?.fiscalYearStart && fiscalYear?.fiscalYearEnd) {
        filters.createdAfter = fiscalYear.fiscalYearStart;
        filters.createdBefore = this.$util
          .getDateInClientTimezone(fiscalYear.fiscalYearEnd)
          .add(1, "day")
          .toDate();
      }

      const params = this.$util.buildPaginationParams(this.options);
      this.$api
        .post(`/api/payouts/search/group/byOrganization?${params.toString()}`, filters)
        .then(({ data }) => {
          this.items = data.content;
          this.total = data.totalElements;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewDealerDetails(dealerId) {
      this.$router.push({ name: "dealerDetails", query: { dealerId } });
    }
  }
};
</script>
